import React, { useEffect, useState } from 'react';
import LayoutOne from '../../layouts/LayoutOne';
import { useDispatch, useSelector } from 'react-redux';
import { getFaqs } from '../../store/actions/faq-action';

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const faqdata = useSelector((state) => state?.faq?.list)
  console.log('faqdata', faqdata)
  const dispatch = useDispatch()
  useEffect(() => {
    const fetchFaq = async () => {
      await dispatch(getFaqs());
    };

    fetchFaq();
  }, [dispatch]);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <LayoutOne>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '40px 20px'
      }}>
        <h2 style={{
          fontSize: '32px',
          fontWeight: '600',
          textAlign: 'center',
          marginBottom: '8px',
          color: '#333'
        }}>
          FAQ's
        </h2>

        <p style={{
          fontSize: '16px',
          textAlign: 'center',
          color: '#666',
          marginBottom: '40px'
        }}>
          simplifying your experience with clear answers
        </p>

        <div>
          {faqdata.map((item, index) => (
            <div
              key={index}
              style={{
                borderBottom: '1px solid #eee',
                marginBottom: '8px',
                backgroundColor: '#fff',
                borderRadius: '4px',
                overflow: 'hidden'
              }}
            >
              <div
                onClick={() => toggleFAQ(index)}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '16px 20px',
                  cursor: 'pointer',
                  backgroundColor: '#fff'
                }}
              >
                <span style={{
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#333'
                }}>
                  {item.que}
                </span>
                <span style={{
                  fontSize: '22px',
                  fontWeight: '300',
                  color: '#666',
                  marginLeft: '10px'
                }}>
                  {activeIndex === index ? '×' : '+'}
                </span>
              </div>

              {activeIndex === index && (
                <div style={{
                  padding: '0 20px 16px 20px',
                  fontSize: '15px',
                  lineHeight: '1.6',
                  color: '#666'
                }}>
                  {item.ans}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </LayoutOne >
  );
};

export default FAQSection;